// extracted by mini-css-extract-plugin
export var legendBlockTitle = "b3_hB";
export var title = "b3_bH";
export var wrapper = "b3_bF";